import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { IonIcon } from '@ionic/react';
import { checkmarkCircle } from 'ionicons/icons';

export const WizardStep = props => {
    const stepClass = classNames({
        'wizard-step--active': props.active,
        'wizard-step--complete': props.complete,
        'wizard-step--disabled': props.disabled
    }, 'wizard-step flex-none py-6 px-3', props.className);

    return (
        <a ref={props.refProp} className={stepClass} onClick={() => !props.disabled && props.onClick()}>
            <div className='wizard-step__icon'>
                { !props.complete ? props.icon : props.successIcon }
            </div>
            <div className='wizard-step__content'>
                { props.children }
            </div>
        </a>
    )
};

WizardStep.defaultProps = {
    successIcon: (<IonIcon icon={checkmarkCircle}></IonIcon>),
    onClick: () => {}
}

WizardStep.propTypes = {
    active: PropTypes.bool,
    complete: PropTypes.bool,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.node,
    successIcon: PropTypes.node,
    children: PropTypes.node
}